import { render, staticRenderFns } from "./Avatar.html?vue&type=template&id=29f75ea6&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.scss?vue&type=style&index=0&id=29f75ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f75ea6",
  null
  
)

export default component.exports